import { Injectable } from '@angular/core';
import { AsyncSubject, Observable } from 'rxjs';

import { WindowShimService } from '®shared/window-shim';

import { RequestDigitisationFinishedReason } from './request-digitisation.actions';

@Injectable()
export class RequestDigitisationService {
  constructor(private window: WindowShimService) {}
  /**
   * Initialises a message event listener and listens for a
   * RequestDigitisationFinishedReason as an Observable.
   *
   * @return {Observable<RequestDigitisationFinishedReason>} - The message from DC which
   * will either be 'close' or 'cancel'.
   */
  getRequestDigitisationFinishedReason(): Observable<RequestDigitisationFinishedReason> {
    const messageSubject =
      new AsyncSubject<RequestDigitisationFinishedReason>();

    // We cannot use PostMessageBridgeFactory because that expects a channel
    // and DC does not use channels.
    this.window.addEventListener('message', (message: MessageEvent) => {
      if (
        message.data === RequestDigitisationFinishedReason.CANCELLED ||
        message.data === RequestDigitisationFinishedReason.COMPLETED
      ) {
        messageSubject.next(message.data);
        messageSubject.complete();
      }
    });

    return messageSubject.asObservable();
  }
}
